import React from 'react';

import { CategoriaCartao } from 'Component/Categoria';
import { useRecuperarCategoriasQuery } from 'Service';

const Default = (): React.ReactElement =>
{
    const { data: { categorias } = {} } = useRecuperarCategoriasQuery({
        limit: 100,
    });

    return (
        <div className="animate__animated animate__fadeIn mt-5 mx-3 mx-sm-0" style={{ minHeight: window.outerHeight }}>
            <div className="container">
                <div className="row">
                    { categorias?.map(categoria => (
                        <div key={ `${categoria.id}-${categoria.modificado}` } className="col-md-3 mb-3">
                            <CategoriaCartao dados={ categoria } />
                        </div>
                    )) }
                </div>
            </div>
        </div>
    )
}

export default Default;
